export default "__VITE_ASSET__DCps0fUU__"